import React from "react";

/**
 * HomyLogo Component for Homy Platform Console
 *
 * Implements the official sovereign brand lockup:
 * - Mark: /homy-mark.png
 * - Wordmark: "Homy" (bold) + "OS" (light)
 * - Platform badge: amber pill
 * - Sovereign component isolation
 */
export function HomyLogo({
  variant = "header",
  showBadge = true,
  subtitle,
  className = "",
}) {
  const isLogin = variant === "login";

  if (isLogin) {
    return (
      <div className={`flex flex-col items-center gap-3 text-center ${className}`}>
        <img
          src="/homy-mark.png"
          alt="HomyOS"
          width={64}
          height={64}
          className="h-16 w-16 mx-auto object-contain rounded-2xl shrink-0"
        />
        <div className="space-y-1">
          <h1 className="text-2xl tracking-tight text-foreground flex items-center justify-center gap-2">
            <span>
              <span className="font-bold text-foreground">Homy</span>
              <span className="font-light text-muted-foreground">OS</span>
            </span>
            {showBadge && (
              <span className="text-xs font-mono font-medium text-amber-500 bg-amber-500/10 border border-amber-500/30 px-2 py-0.5 rounded-full uppercase tracking-wider">
                Platform
              </span>
            )}
          </h1>
          {subtitle && (
            <p className="text-xs text-muted-foreground">{subtitle}</p>
          )}
        </div>
      </div>
    );
  }

  // Header / Default Command Center variant
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <img
        src="/homy-mark.png"
        alt="HomyOS"
        width={36}
        height={36}
        className="h-9 w-9 rounded-lg object-contain shrink-0"
      />
      <div>
        <div className="flex items-center gap-2">
          <span className="tracking-tight text-sm">
            <span className="font-bold text-white">Homy</span>
            <span className="font-light text-slate-400">OS</span>
          </span>
          {showBadge && (
            <span className="text-amber-400 text-xs font-mono font-medium uppercase tracking-wider">
              Platform
            </span>
          )}
        </div>
        {subtitle && (
          <p className="text-[10px] text-slate-400 font-mono">{subtitle}</p>
        )}
      </div>
    </div>
  );
}

export default HomyLogo;
